import { getTemplateNavHeaderSearchContainerStyles } from './NavHeaderSearchContainer.styles'

const t = document.createElement('template')
t.innerHTML = `
<div class="search-container">
  <slot></slot>
</div>
`

class NavHeaderSearchContainer extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(getTemplateNavHeaderSearchContainerStyles().content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderSearchContainer connectedCallback', this)
  }

  static get observedAttributes() {
    return ['display-mode', 'search-visible']
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    this.updateCssClasses();

    if (name === 'display-mode') {
      const container = this.shadowRoot?.querySelector('div')
      if (newValue === 'mobile') {
        container?.classList.add('mobile-only')
        container?.classList.remove('mobile-hidden')
      } else {
        container?.classList.remove('mobile-only')
        container?.classList.add('mobile-hidden')
      }
    } else if (name === 'search-visible') {
      const container = this.shadowRoot?.querySelector('div')
      if (newValue === 'true') {
        container?.classList.add('open')
        container?.classList.remove('closed')
      } else {
        container?.classList.remove('open')
        container?.classList.add('closed')
      }
    }
  }

  private updateCssClasses() {
    const container = this.shadowRoot?.querySelector('.search-container')
    if (!container) return

    const isVisible = this.getAttribute('search-visible') === 'true'
    const displayMode = this.getAttribute('display-mode')

    // Reset classes
    container.classList.remove('open', 'closed', 'mobile-only', 'mobile-hidden')
    this.classList.remove('mobile-only', 'mobile-hidden')

    // Set display-mode classes
    if (displayMode === 'mobile') {
      container.classList.add('mobile-only')
      this.classList.add('mobile-only')
    } else if (displayMode === 'desktop') {
      container.classList.add('mobile-hidden')
      this.classList.add('mobile-hidden')
    }

    // Toggle search visibility
    if (isVisible) {
      container.classList.add('open')
      container.classList.remove('closed')
    } else {
      container.classList.add('closed')
      container.classList.remove('open')
    }
  }
}



customElements.define('ts-navheader-search-container', NavHeaderSearchContainer)
